<div class="container">
    <app-header></app-header>
    <p-toast></p-toast>
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>